import React, { memo } from 'react';
import { SectionWithWidgets } from '../../types/api/Sections';
import { ContentMultiColumn, ContentMultiColumnSection } from './ContentMultiColumn';
import { Content } from './Content';

type ContentSectionProps = {
  className: string;
  section: SectionWithWidgets;
  contentMultiColumn?: ContentMultiColumnSection;
};

export const ContentContainer = memo(
  function ({ className, section, contentMultiColumn }: ContentSectionProps) {
    ContentContainer.displayName = 'ContentContainer';
    return (
      <div className={className}>
        <Content section={section} />
        {contentMultiColumn && <ContentMultiColumn section={contentMultiColumn} />}
      </div>
    );
  },
  (prevProps, nextProps) => prevProps.section.uuid === nextProps.section.uuid
);
